<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Tipo de Projeto</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroTipoProjeto" ref="formCadastroTipoProjeto" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.id" label="Código" readonly dense outlined/>
                        </v-col>
                        <v-col cols="12" md="10">
                            <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import {TipoProjetoService} from '../../../core/services/projetos';
import {TipoProjeto} from '../../../core/domain/projetos';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroTipoProjeto' in this.$refs)
                this.$refs.formCadastroTipoProjeto.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new TipoProjetoService(),
        valid: true,
        dialog: false,
        isLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formCadastroTipoProjeto.validate()) {

                this.salvando = true;

                let modelo = new TipoProjeto(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title, 'warning')
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }

        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

    }
}
</script>